var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYapero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2000,
    height: 2000,
    viewBox: "0 0 2000 2000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2000,
    height: 2000,
    rx: 500,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491 1646L700.354 1055.11C724.65 986.538 775.12 930.365 840.732 898.872C893.096 873.737 936.167 832.696 963.787 781.619L1155.62 426.844C1146.94 423.771 1142.39 414.244 1145.47 405.565L1153.87 381.866C1161.58 360.099 1185.49 348.701 1207.26 356.41L1387.12 420.066C1408.9 427.774 1420.3 451.669 1412.59 473.437L1404.19 497.135C1401.12 505.814 1391.59 510.359 1382.9 507.285L1308.6 903.662C1297.91 960.728 1305.54 1019.71 1330.41 1072.18C1361.57 1137.93 1365.42 1213.33 1341.12 1281.9L1227.79 1601.77L1149.63 1631.32C1071.83 1660.74 983.958 1640.62 926.738 1580.27C851.327 1500.73 726.871 1493.98 643.293 1564.9L613.621 1590.07C578.129 1620.18 535.553 1639.16 491 1646Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 0,
    x2: 1000,
    y2: 2000,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB00F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB009A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYapero);
export default __webpack_public_path__ + "static/media/yapero.fbdb51c73ebbd7d42c6e1124dcff326f.svg";
export { ForwardRef as ReactComponent };